import { render, staticRenderFns } from "./PaymentButtonWrapper.vue?vue&type=template&id=6556bc7a&"
import script from "./PaymentButtonWrapper.vue?vue&type=script&lang=js&"
export * from "./PaymentButtonWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports